<div class="au-gold-wrapper">
  <div class="modal-header-row">
    <h2 class="modal-title">Accessing Specialty Programs</h2>
    <button type="button" class="close-btn" (click)="cancel()" aria-label="Close">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <p class="modal-text">
    To access our specialty lines, please log in via the AU Gold portal.
  </p>

  <hr class="divider" />

  <h3 class="section-heading">Don't have login credentials?</h3>
  <p class="modal-text">
    If you need login information for our Specialty Programs Portal, please email
    <a class="email-link" href="mailto:{{contactEmail}}">{{contactEmail}}</a>.
    Once your request has been processed, you will receive a confirmation email with your
    login credentials and instructions for accessing the portal.
  </p>

  <div class="actions">
    <button class="outline btn-md" (click)="back()">Back</button>
    <button class="primary btn-md" (click)="openAuGoldPortal()">
      <i class="bi bi-box-arrow-up-right"></i>
      <span>Continue to AU Gold Portal</span>
    </button>
  </div>
</div>
